import { LogLevel } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Identity provider settings.
//
// The authorities are supplied whole rather than assembled from a domain, tenant
// and policy, because only B2C has a policy segment: External ID authorities are
// https://<subdomain>.ciamlogin.com/<tenantId>. Moving between the two is then a
// change of environment variables, not of code.
const apiURI = import.meta.env.VITE_API_URI;
const clientId = import.meta.env.VITE_AUTH_CLIENT_ID;
const signInAuthority = import.meta.env.VITE_AUTH_AUTHORITY;
// B2C runs password reset as its own policy. External ID has no equivalent, so
// this is optional and the settings page hides the button without it.
const resetPasswordAuthority = import.meta.env.VITE_AUTH_RESET_AUTHORITY;

const list = (value) =>
  (value ?? "")
    .split(",")
    .map((entry) => entry.trim())
    .filter(Boolean);

const knownAuthorities = list(import.meta.env.VITE_AUTH_KNOWN_AUTHORITIES);
const scopes = list(import.meta.env.VITE_AUTH_SCOPES);

export const authPolicies = {
  authorities: {
    signIn: { authority: signInAuthority },
    resetPassword: resetPasswordAuthority
      ? { authority: resetPasswordAuthority }
      : null,
  },
};

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: signInAuthority,
    knownAuthorities: knownAuthorities,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
  scopes: scopes,
};

export const apiConfig = {
  scopes: scopes,
  uri: apiURI,
};
